import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';

const menuItemLabel = (menuItems, obj) =>
  menuItems[obj].label || menuItems[obj].name || menuItems[obj].toString();

class WaveSelectField extends React.Component {
  render() {
    const multiple = this.props.multiple;
    const value = multiple
      ? this.props.value || []
      : this.props.value == null
      ? ''
      : this.props.value + '';
    const menuItems = this.props.menuItems;
    const tooltipProps = this.props.tooltipProps;

    return (
      <FormControl variant="standard" fullWidth error={this.props.error}>
        <InputLabel>
          {this.props.label}
          {tooltipProps && (
            <Tooltip
              disableFocusListener
              classes={{
                popper: tooltipProps.tooltipPopper,
                tooltip: tooltipProps.tooltipContainer
              }}
              placement={tooltipProps.placement}
              title={tooltipProps.titleComponent}
            >
              <span> ⓘ</span>
            </Tooltip>
          )}
        </InputLabel>
        <Select
          ref={this.props.innerRef}
          variant="standard"
          name={this.props.name}
          onChange={this.props.onChange}
          value={value}
          multiple={multiple}
          renderValue={
            multiple
              ? (selected) =>
                  selected.indexOf('all') > -1 ||
                  (selected.length === 0 && this.props.filterByAllItem)
                    ? this.props.filterByAllItemLabel || 'All'
                    : selected
                        .map((selectedValue) =>
                          menuItems && menuItems[selectedValue]
                            ? menuItemLabel(menuItems, selectedValue)
                            : selectedValue
                        )
                        .join(', ')
              : undefined
          }
        >
          {this.props.emptyMenuItem ? (
            <MenuItem component="div" key="null" value={null}>
              {this.props.emptyMenuItemLabel || ''}
            </MenuItem>
          ) : null}

          {this.props.filterByAllItem ? (
            <MenuItem component="div" key="null" value="all">
              {multiple && (
                <Checkbox checked={value.indexOf('all') > -1} />
              )}
              {this.props.filterByAllItemLabel || ''}
            </MenuItem>
          ) : null}

          {menuItems &&
            Object.keys(menuItems).map((obj) => (
              <MenuItem
                component="div"
                key={obj}
                value={menuItems[obj].value || obj}
              >
                {multiple && (
                  <Checkbox
                    checked={value.indexOf(menuItems[obj].value || obj) > -1}
                  />
                )}
                {multiple ? (
                  <ListItemText primary={menuItemLabel(menuItems, obj)} />
                ) : (
                  menuItemLabel(menuItems, obj)
                )}
                {menuItems[obj].hasOwnProperty('active') &&
                  menuItems[obj].active === false &&
                  ' (deactivated)'}
              </MenuItem>
            ))}

          {this.props.otherItem ? (
            <MenuItem component="div" key="other" value="other">
              {this.props.otherItemLabel || ''}
            </MenuItem>
          ) : null}
        </Select>
        {this.props.noValidation ? (
          ''
        ) : (
          <FormHelperText>{this.props.helperText}</FormHelperText>
        )}
      </FormControl>
    );
  }
}

export default React.forwardRef((props, ref) => (
  <WaveSelectField innerRef={ref} {...props} />
));
